export enum PageActionType {
  /*
   | ---------------------------------------------------------------------------
   | Page Draft Creation Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for creating a new page draft. New page drafts may be
   | based on an existing page or may create a new (empty) page.
   |
   */
  CreatePageError = 'drafts/pages/CREATE_ERROR',
  CreatePageRequest = 'drafts/pages/CREATE_REQUEST',
  CreatePageSuccess = 'drafts/pages/CREATE_SUCCESS',

  DuplicatePage = 'pages/DUPLICATE',

  /*
   | ---------------------------------------------------------------------------
   | Page Draft Load Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for loading existing page drafts into state from the
   | server.
   |
   */
  LoadPageError = 'drafts/pages/LOAD_ERROR',
  LoadPageRequest = 'drafts/pages/LOAD_REQUEST',
  LoadPageSuccess = 'drafts/pages/LOAD_SUCCESS',

  /*
   | ---------------------------------------------------------------------------
   | Page Draft Promotion Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are related to promoting a page draft to an active page.
   | Promoting a page draft replaces the value of a page with the draft's
   | content.
   |
   */
  PromotePageError = 'drafts/pages/PROMOTE_ERROR',
  PromotePageRequest = 'drafts/pages/PROMOTE_REQUEST',
  PromotePageSuccess = 'drafts/pages/PROMOTE_SUCCESS',

  /*
   | ---------------------------------------------------------------------------
   | Page Draft Setter Actions
   | ---------------------------------------------------------------------------
   |
   | These actions work with the value of
   |
   */
  SetPageCategoryIds = 'drafts/pages/SET_CATEGORY_IDS',
  SetPageContent = 'drafts/pages/SET_CONTENT',
  SetPageContentType = 'drafts/pages/SET_CONTENT_TYPE',
  SetPageDescription = 'drafts/pages/SET_DESCRIPTION',
  SetPageDiscourageIndexing = 'drafts/pages/SET_DISCOURAGE_INDEXING',
  SetPagePinterestDescription = 'drafts/pages/SET_PINTEREST_DESCRIPTION',
  SetPagePageId = 'drafts/pages/SET_PAGE_ID',
  SetPagePath = 'drafts/pages/SET_PATH',
  SetPagePublishAt = 'drafts/pages/SET_PUBLISH_AT',
  SetPageTagIds = 'drafts/pages/SET_TAG_IDS',
  SetPageTags = 'drafts/pages/SET_TAGS',
  SetPageTitle = 'drafts/pages/SET_TITLE',
  SetPageUnpublishAt = 'drafts/pages/SET_UNPUBLISH_AT',
  SetPosterImages = 'page/SET_POSTER_IMAGES',

  // TODO: add actions for uploading images...

  /*
   | ---------------------------------------------------------------------------
   | Page Draft Update Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for updating existing page drafts. When an update occurs
   | the contents of the page draft is replaced.
   |
   */
  UpdatePageError = 'drafts/pages/UPDATE_ERROR',
  UpdatePageRequest = 'drafts/pages/UPDATE_REQUEST',
  UpdatePageSuccess = 'drafts/pages/UPDATE_SUCCESS',
}
